
$( document ).ready(function() {

  $('.js-kit_bundler-products-picker-trigger_button').click(function(){
    
    let $this = $(this);
    if ($this.hasClass('button-active'))
    {
      $('.js-kit_bundler-products-picker-trigger_button').removeClass('button-active');
      $('.js-kit_bundler-products-picker-products').hide();
    }
    else 
    {
      $('.js-kit_bundler-products-picker-trigger_button').removeClass('button-active');
      $this.addClass('button-active');
      
      $('.js-kit_bundler-products-picker-products').hide();
      $(this).next('.js-kit_bundler-products-picker-products').show();
    }
   
});

  $('.js-kit_bundler-products-picker-products-product_button').click(function(){
    let $this = $(this);
    let upsellVariantId = $this.attr('data-variant-id');
    let mainFormInput = $this.closest('.kit_bundler-products-picker').find('input.js-kit_bundler-products-picker-product_id_input');
    let productImageSrc = $this.attr('data-image-src');
    let mainProductSelector = $this.parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-trigger_button');
    let totalProductCount = parseFloat($this.closest('.kit_bundler-products').attr('data-product-count'));
    if ( mainProductSelector.find('img').length )
    {
      mainProductSelector.find('img').attr('src', productImageSrc)
    }
    else
    {
       mainProductSelector.find('svg').remove();
    let selectedImg = $('<img />', {
        class: 'kit_bundler-products-picker-trigger_button-image',
        src: productImageSrc,
        alt: 'Color Image'
      });
    mainProductSelector.append(selectedImg);
    }
    mainFormInput.val(upsellVariantId);
    $('.js-kit_bundler-products-picker-trigger_button').removeClass('button-active');
    $('.js-kit_bundler-products-picker-products').hide();
    if (! mainProductSelector.hasClass('js-done')) {
    let oldcounterValue = $this.closest('form').find('.js-kit_bundler-products_heading-count').text();
    let newVal = parseFloat(oldcounterValue) + 1;
    $this.closest('form').find('.js-kit_bundler-products_heading-count').text(newVal);
    }
    mainProductSelector.addClass('js-done');
    let latestcountValue = parseFloat($this.closest('form').find('.js-kit_bundler-products_heading-count').text());
    if (latestcountValue === totalProductCount) {
      console.log('hello')
       $('#customAddToCartUpsells').find('span.add_to_cart-text').text('Lägg till i varukorgen');
      $('#customAddToCartUpsells').removeAttr("disabled");
      $('#AddToCart').removeClass('disabled--button').removeAttr("disabled");
    }
    else{
      $('#customAddToCartUpsells').attr("disabled", "True" );
      $('#customAddToCartUpsells').find('span.add_to_cart-text').text('Slutför valet av hårfärger');
      $('#AddToCart').hide().addClass('disabled--button hide').attr("disabled", "True" );
    }
    
  });
  
  $('.main-varient-box input[type=radio][data-index=option1]').change(function() {
    // $('#AddToCart').attr("disabled", true);
    $('.kit_bundler-products').hide();
    $('form.kit_bundler-form').hide().removeClass('active');
    console.log("::::::::::::::: this.atributes('data-variant-label')::  ", this.value);
      if ($(this).attr('data-variant-label') == 'Starter') {
        $('form.kit_bundler-form[data-type="first-variant"]').show().addClass('active');
        $('.kit_bundler-products[data-option=1]').show();
      }
      else if ($(this).attr('data-variant-label') == 'Essential')
      {
        $('form.kit_bundler-form[data-type="second-variant"]').show().addClass('active');
        $('.kit_bundler-products[data-option=2]').show();
      }
    else
      {
        $('form.kit_bundler-form[data-type="third-variant"]').show().addClass('active');
        $('.kit_bundler-products[data-option=3]').show();
      }


    let totalProductCount = parseFloat($('form.kit_bundler-form.active').find('.kit_bundler-products').attr('data-product-count'));
    let counterValue = $('form.kit_bundler-form.active').find('.js-kit_bundler-products_heading-count').text();
    counterValue = parseFloat(counterValue);

    if (counterValue === totalProductCount) {
      $('#customAddToCartUpsells').find('span.add_to_cart-text').text('Lägg till i varukorgen');
      $('#customAddToCartUpsells').removeAttr("disabled");
      $('#AddToCart').removeClass('disabled--button').removeAttr("disabled");
    }
    else{
      $('#customAddToCartUpsells').attr("disabled", "True" );
      $('#customAddToCartUpsells').find('span.add_to_cart-text').text('Slutför valet av hårfärger');
      $('#AddToCart').hide().addClass('disabled--button hide').attr("disabled", "True" );
    }
      
    
});

  $('.kit_bundler-promo-details-content-cta').click(function(){
    let goToValue = $(this).attr('value');
    $(".block-swatch__radio[value="+ goToValue +"]").click();
  });

  $('#customAddToCartUpsells').click(function(e){
    e.preventDefault();
    let $this = $(this);
    $this.addClass('is-loading');
    $(this).find('span.add_to_cart-text').hide();
    $(this).find('span.loader-button__loader').css('display', 'contents');
    let addToCartForm = document.querySelector('form.kit_bundler-form.active');
    let formData = new FormData(addToCartForm);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      $('.main-product-atc').click();
      $this.removeClass('is-loading');
    })
    .catch((error) => {
      // alert(error);
      console.error('Error:', error);
      $this.removeClass('is-loading');
    });
    setTimeout(function() { 
      // $this.removeClass('is-loading');
      $('#customAddToCartUpsells').find('span.add_to_cart-text').show();
      $('#customAddToCartUpsells').find('span.loader-button__loader').hide();
    }, 1000);
  });


    const classToHide = document.querySelectorAll('.kit_bundler-products-picker-products-product_button-label');
     classToHide.forEach((element) => {
      const content = element.innerHTML;
      const updatedContent = content.replace(/ DP/g,'');
      element.innerHTML = updatedContent;
    });
  
  });

$(document).ready(function() {
  // When a radio in the first fieldset changes
  $('fieldset.variant-input-wrap input[type=radio]').on('change', function() {
    var selectedValue = $(this).val();
    // Find matching radio in second fieldset and trigger click (not just check)
    $('fieldset.radio__fieldset input[type=radio]').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).trigger('click');
        // or $(this).click();
      }
    });
  });

  // When a radio in the second fieldset changes
  $('fieldset.radio__fieldset input[type=radio]').on('change', function() {
    var selectedValue = $(this).val();
    // Find matching radio in first fieldset and trigger click
    $('fieldset.variant-input-wrap input[type=radio]').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).trigger('click');
      }
    });
  });

  $(".collection-tabs-wrapper").each(function () {
    const $wrapper = $(this);
    const $tabs = $wrapper.find(".collection-tab");
    const $collections = $wrapper.find(".collection-products");

    // Default: Activate the first tab and show its products
    const $firstTab = $tabs.first();
    const firstCollectionHandle = $firstTab.data("collection");

    $tabs.removeClass("active");
    $collections.removeClass("active"); // Remove active class from all collections

    $firstTab.addClass("active");
    $wrapper.find(`.collection-products[data-collection="${firstCollectionHandle}"]`).addClass("active"); // Add active class to first collection

    // On click: switch active tab and show corresponding collection
    $tabs.on("click", function () {
      const $this = $(this);
      const collectionHandle = $this.data("collection");

      $tabs.removeClass("active");
      $collections.removeClass("active");

      $this.addClass("active");
      $wrapper.find(`.collection-products[data-collection="${collectionHandle}"]`).addClass("active");
    });
});

});
